import {useInfiniteQuery} from 'react-query';
import {getShopPosts} from '../../../../services/shop/posts';

const UseGetShopProducts = (id: string) => {
  const {data, isLoading, fetchNextPage} = useInfiniteQuery(
    ['shopPosts'],
    ({pageParam = 1}) => getShopPosts(id || '', pageParam),
    {
      getNextPageParam: (_, allPages) => {
        return allPages[allPages.length - 1]?.next
          ? new URL(allPages[allPages.length - 1]?.next || '').searchParams.get(
              'page',
            )
          : undefined;
      },
    },
  );

  return {data, isLoading, fetchNextPage};
};

export default UseGetShopProducts;
